// Area room state, Schema v1-sprint (92 §3.2, 43 §4). Server and client import
// the same classes. Field order is wire format: append only, never reorder.
import { schema, t } from '@colyseus/schema';
export const Mover = schema({
    x: t.uint16().default(0), // tile where `path` starts (= current tile when idle)
    y: t.uint16().default(0),
    path: t.string().default(''), // PackedPath, "" = idle
    startAt: t.uint32().default(0), // RoomMs at which the mover leaves (x, y)
    gait: t.uint8().default(0), // Gait
    facing: t.uint8().default(0), // Facing when idle
    seq: t.uint16().default(0), // last accepted MoveIntent.seq (owner reconciliation, 43 §3.4)
}, 'Mover');
export const Activity = schema({
    kind: t.uint8().default(0), // 0 none; doc 10 owns the list
    obj: t.uint16().default(0), // map object oid, 0 = none
    startAt: t.uint32().default(0),
}, 'Activity');
export const Player = schema({
    eid: t.uint32().default(0),
    name: t.string().default(''),
    body: t.uint8().default(0), // Body: 0 male, 1 female
    look: t.string().default(''), // item net ids per layer (98 Q-21)
    mover: Mover,
    act: Activity,
    flags: t.uint8().default(0), // PresenceFlag bits
}, 'Player');
export const World = schema({
    power: t.uint8().default(0), // 0 off, 1 on
    powerSince: t.uint32().default(0), // RoomMs
    epochMs: t.float64().default(0), // Date.now() at RoomMs 0
}, 'World');
export const Stall = schema({
    slot: t.uint8().default(0),
    ownerEid: t.uint32().default(0), // 0 = free
    open: t.boolean().default(false),
    queueLen: t.uint8().default(0),
}, 'Stall');
export const AreaState = schema({
    players: t.map(Player), // key = eidKey(eid)
    stalls: t.map(Stall), // key = String(slot)
    world: World,
}, 'AreaState');
